import { render, staticRenderFns } from "./Assistenza-clienti.vue?vue&type=template&id=3a7822ca&scoped=true&"
import script from "./Assistenza-clienti.vue?vue&type=script&lang=js&"
export * from "./Assistenza-clienti.vue?vue&type=script&lang=js&"
import style0 from "./Assistenza-clienti.vue?vue&type=style&index=0&id=3a7822ca&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7822ca",
  null
  
)

export default component.exports